import { CommonModule } from "@angular/common";
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";

export interface Draft {
  name: string;
  id: number;
  progressText: string;
  progressPercent: number;
  lastUpdatedDate: string;
  lastUpdatedText: string;
}

@Component({
  selector: "app-draft-card",
  imports: [CommonModule, MatButtonModule],
  templateUrl: "./draft-card.component.html",
  styleUrl: "./draft-card.component.scss",
})
export class DraftCardComponent {
  @Input() draft!: Draft;
  @Output() continue = new EventEmitter<string>();

  handleContinueDraft(): void {
    this.continue.emit(this.draft.id.toString());
  }
}
